import { render } from "./matching-list-interests-targets.vue?vue&type=template&id=996bf6ce&scoped=true&ts=true"
import script from "./matching-list-interests-targets.vue?vue&type=script&lang=ts"
export * from "./matching-list-interests-targets.vue?vue&type=script&lang=ts"

import "./matching-list-interests-targets.vue?vue&type=style&index=0&id=996bf6ce&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-996bf6ce"]])

export default __exports__